import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { apiPostJson, type FeedbackReceipt, type FeedbackRequest } from "@/shared/api";

/**
 * Files a problem report.
 *
 * `retry: false`, and that is the important line. A retried POST that actually
 * succeeded the first time - a response lost on the way back, say - files the
 * same report twice, and the second copy is indistinguishable from the first.
 * Duplicates are what stop a feedback channel being read, so a failure the
 * reporter can see and repeat deliberately is the better trade.
 */
export function useSubmitFeedback(): UseMutationResult<FeedbackReceipt, Error, FeedbackRequest> {
  return useMutation({
    mutationFn: (report: FeedbackRequest) => apiPostJson<FeedbackReceipt>("/feedback", report),
    retry: false,
  });
}
